import './bt-grid.scss';

export default function BtGrid({className = "", children, ...props}) {
  return <div className={`bt-grid hydrated ${className}`} {...props}>{children}</div>
}